import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getAsigneList';

export const getAsigneList = (endpoint = ENDPOINT) => {
    return network.post(endpoint).then((response) => response.data);
};
